import { AllocationViewActionIdentifierModel } from '../../models';

export class AllocationViewCallToWaitingAreaActionSetInitialState {
  public static readonly type = '[AllocationViewCallToWaitingAreaAction] Set Initial State';
}

export class AllocationViewCallToWaitingAreaAction {
  public static readonly type = '[AllocationViewCallToWaitingAreaAction] Call To Waiting Area';

  constructor(
    public payload: {
      identifier: AllocationViewActionIdentifierModel;
    },
  ) {}
}

export class AllocationViewCallToWaitingAreaActionSetCloseAfterCompleteState {
  public static readonly type = '[AllocationViewCallToWaitingAreaAction] Set Close After Complete State';

  constructor(public payload: boolean) {}
}
